import { UserException } from '@/domain/user/exception/UserException'

export class CannotEditEmailException extends UserException {

}
